import React from 'react';
import { ActionField } from 'components/fields';
import RefundField from './RefundField';
import CancelAchTransactionField from './CancelAchTransactionField';
import CheckAchBalanceField from './CheckAchBalanceField';
import RequestBankVerificationField from './RequestBankVerificationField';
import CheckAchTransactionsField from './CheckAchTransactionsField';
import ReleaseAchFundsField from './ReleaseAchFundsField';
import { VERDICT_NO_TRANSACTIONS_ACCESS } from './achVerificationTypes';

const TransactionActionsField = (props) => {
  const { record, currencyCode, onRefund } = props;

  const isRefunded =
    record?.transactions &&
    record.transactions[0]?.details?.receiptDetails?.refundStatus === 'succeeded';

  const isCurrency =
    record?.transactions && record.transactions[0]?.amount?.currency === currencyCode;

  const isPendingAch = !!record?.details?.achAllocation && record.status === 'PENDING';

  const hideCancelAction = !isPendingAch;

  // RLPR-20420 bank balance check is only meaningful while the ACH debit is still unsettled
  const hideBalanceCheckAction = !isPendingAch || !record?.details?.paymentIntentId;

  // RLPR-20420 bank transactions check and early release: same window as the balance check, and the release
  // additionally needs something left to release
  const hideTransactionsCheckAction = hideBalanceCheckAction;
  // the relink request is only needed when a check found no bank link with transactions access (bank accounts
  // linked since RLPR-20420 already share transactions); it stays once requested so support can re-send the
  // link. The check dialog offers it directly on that verdict, this menu entry is the way back to it.
  const verification = record?.details?.bankVerification;
  const hideVerificationAction =
    hideBalanceCheckAction ||
    !(verification?.lastVerdict === VERDICT_NO_TRANSACTIONS_ACCESS || verification?.requestedAt);
  const hideReleaseAction =
    hideBalanceCheckAction || !(record?.details?.achAllocation?.pendingAmountCents > 0);

  const hideRefundAction =
    record.type !== 'DEPOSIT' || record?.status !== 'CONFIRMED' || isRefunded || !isCurrency;

  if (
    hideRefundAction &&
    hideCancelAction &&
    hideBalanceCheckAction &&
    hideVerificationAction &&
    hideTransactionsCheckAction &&
    hideReleaseAction
  ) {
    return null;
  }

  return (
    <ActionField>
      <RefundField onRefund={onRefund} record={record} hideAction={hideRefundAction} />
      <CheckAchBalanceField record={record} hideAction={hideBalanceCheckAction} />
      <RequestBankVerificationField record={record} hideAction={hideVerificationAction} />
      <CheckAchTransactionsField record={record} hideAction={hideTransactionsCheckAction} />
      <ReleaseAchFundsField record={record} hideAction={hideReleaseAction} />
      <CancelAchTransactionField record={record} hideAction={hideCancelAction} />
    </ActionField>
  );
};

export default TransactionActionsField;
